/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { actions as headerActions } from '@gerenciatd/next.app-controller.reducers-sagas.header-reducer';
import DisplayOnViewPort from '@gerenciatd/next.utils.display-on-viewport-intersection';
import Header from "@gerenciatd/next.components.header-n";
import dynamic from "next/dynamic";
import Footer from "@/components/footer";

// making dicctionary
import TextInfo from '@gerenciatd/next.components.text-info-n'
import FeaturedProducts from '@/components/featured-products'
import TvSlider from '@/components/tv-slider'
import Price from '@gerenciatd/next.components.price'
import Label from '@gerenciatd/next.components.label'
import Image from '@gerenciatd/next.components.image-n'
import ShopDevices from '@/components/shop-devices'
import ProductSuggest from '@/components/product-suggest'
import Banner from '@/components/banner-home'
import ShortClick2Action from '@/components/short-click-to-action'

const CustomizerComponent = dynamic(() => import('@/components/customizer-component'));
const LegoComponent = dynamic(() => import('@/components/lego-component'));

import { actions as mainActions } from "@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n";
import { actions as custoActions } from "@/reducers/custo-reducer";

import { END } from "redux-saga";
import { wrapper } from "@/store";
// single change
const dictionary = {
  'Banner': Banner,
  'FeaturedProducts': FeaturedProducts,
  'ProductSuggest': ProductSuggest,
  'ShopDevices': ShopDevices,
  'TvSlider': TvSlider,
  'TextInfo': TextInfo,
  'Price': Price,
  'Label': Label,
  'Image': Image,
  'ClickToConfig': ShortClick2Action,
};

const CREATIVITY_ID_1 = "LightHouse_Home_Tienda_electronica";
const CREATIVITY_ID_2 = "LightHouse_Home_Tv_slider";
const CREATIVITY_ID_3 = "LightHouse_Home_Productos_Sugeridos";
const CREATIVITY_ID_4 = "LightHouse_Destacados_Actividad";
const CREATIVITY_ID_5 = "LightHouse_Home_Banner_Actividad";
const CREATIVITY_ID_6 = "LightHouse_Home_Configurador";

const Home = ({ creativities }) => {

  return (
    <>
      <Header />
      <div className="HomeParticulares">
        <CustomizerComponent
          creativityId={CREATIVITY_ID_5}
          Component={LegoComponent}
          dictionary={dictionary}
          kind="activity"
          fakeLoadingProps={{
            desktop: '500px',
            tablet: '500px',
            mobile: '667px', 
          }}
        />
        <CustomizerComponent
          creativityId={CREATIVITY_ID_6}
          Component={LegoComponent}
          dictionary={dictionary}
          rawData={{
            ...creativities[CREATIVITY_ID_6]
          }}
        />
        <CustomizerComponent  
          creativityId={CREATIVITY_ID_4} 
          Component={LegoComponent}
          dictionary={dictionary}
          kind="activity"
          fakeLoadingProps={{
            desktop: '596px',
            tablet: '600px',
            mobile: '600px', 
          }}
        />
        <DisplayOnViewPort>
          <CustomizerComponent
            creativityId={CREATIVITY_ID_1}
            Component={LegoComponent}
            dictionary={dictionary}
          />
        </DisplayOnViewPort>
      <CustomizerComponent 
        creativityId={CREATIVITY_ID_3}
        Component={LegoComponent}
        dictionary={dictionary}
      />
        <DisplayOnViewPort>
          <CustomizerComponent
            creativityId={CREATIVITY_ID_2}
            Component={LegoComponent}
            dictionary={dictionary}
          />
        </DisplayOnViewPort>
      </div>
      <Footer />
    </>
  );
};

export default Home;

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  store.dispatch(mainActions.getCurrentSeo({SEG_NAV: "particulares",location: "www.movistar.es",customValues: "{}"}));
  store.dispatch(
    headerActions.getHeaderInfo({
      pathname: '/particulares',
    })
  );
  store.dispatch(
    headerActions.getFooterInfo({
      pathname: '/particulares',
    })
  );


  store.dispatch(custoActions.getCreativity({
    creativityId: CREATIVITY_ID_1,
    build: true,
  }));
  store.dispatch(custoActions.getCreativity({
    creativityId: CREATIVITY_ID_2,
    build: true,
  }));
  store.dispatch(custoActions.getCreativity({
    creativityId: CREATIVITY_ID_3,
    build: true,
  }));
  store.dispatch(custoActions.getCreativity({
    creativityId: CREATIVITY_ID_6,
    build: true,
  }));
  store.dispatch(END);
  await store.sagaTask.toPromise();

  return {
    props:{
      creativities: store.getState().custo.creativities,
    }
  }
});
